import React from "react";

export default function AdminEmptyState({ title, description, icon, action, className = "" }: { title: React.ReactNode, description?: React.ReactNode, icon?: React.ReactNode, action?: React.ReactNode, className?: string }) {
    return (
        <div className={`flex flex-col items-center justify-center text-center gap-2 rounded-xl border border-dashed border-gray-300 bg-gray-50/60 px-6 py-10 ${className}`}>
            {
                icon ?
                    <div className="mb-1 flex h-11 w-11 items-center justify-center rounded-full bg-white text-gray-400 ring-1 ring-gray-200">{icon}</div>
                    : null
            }
            <p className="text-sm font-semibold text-gray-700">{title}</p>
            {
                description ?
                    <p className="text-sm text-gray-500 max-w-md">{description}</p>
                    : null
            }
            {
                action ?
                    <div className="mt-3">{action}</div>
                    : null
            }
        </div>
    )
}
